import {EventEmitter} from '@billjs/event-emitter';


export default class ChatDialog extends EventEmitter{

  constructor(){
    super();
    this.chatHeight = {"elder":0,"young":0};
    this.chatTms = [];
  }

  clearChat(speaker = "elder"){
    let parent = document.getElementById("chat-container");
    if(speaker == "young"){
      parent = document.getElementById("chat-container-young");
    }
    parent.innerHTML = "";
    parent.style.height = "0px";
    this.chatHeight[speaker] = 0;
  }

  clearAllChats(){
    this.chatTms.forEach((item, i) => {
      clearTimeout(item);
    });

    let parent = document.getElementById("chat-container");

    parent.innerHTML = "";
    parent.style.height = "0px";
    this.chatHeight['elder'] = 0;

    parent = document.getElementById("chat-container-young");
    parent.innerHTML = "";
    parent.style.height = "0px";
    this.chatHeight['young'] = 0;

  }

  hideAllChats(speaker = "elder"){
    this.chatTms.forEach((item, i) => {
      clearTimeout(item);
    });

    let parent = document.getElementById("chat-container");
    if(speaker == "young"){
      parent = document.getElementById("chat-container-young");
    }
    let chatChildren = parent.querySelectorAll(".chat-bubble");
    chatChildren.forEach((child, i) => {
      child.classList.remove("show");
    });
    this.hidden = true;
  }

  showAllChats(speaker = "elder"){
    let parent = document.getElementById("chat-container");
    if(speaker == "young"){
      parent = document.getElementById("chat-container-young");
    }
    let chatChildren = parent.querySelectorAll(".chat-bubble");
    chatChildren.forEach((child, i) => {
      child.classList.add("show");
    });
    this.hidden = false;
  }

  toggleChats(){

    if(this.hidden){
      this.showAllChats();
    }else{
      this.hideAllChats();
    }
  }

  addChat(text,speaker="elder",buttonData = null,classToAdd = null){

    this.hidden = false;
    let parent = document.getElementById("chat-container");

    if(speaker == "young"){
      parent = document.getElementById("chat-container-young");
    }

    let prevChats = parent.querySelectorAll(".chat-bubble");

    let lastChat = null;
    if(prevChats.length > 0){
      lastChat = prevChats[prevChats.length - 1];
    }

    if (text == '...') {
      text = "<div class='bubble-text-loading'></div>";
    }
    // create the temp element
    let newChat = document.createElement("div");
    newChat.classList.add("chat-bubble",speaker,"hidden","hiddenBB");

    if(classToAdd === "riddle") {
      newChat.classList.add("riddle-bubble");
    } else if (classToAdd) {
      newChat.classList.add(classToAdd);
    }

    if(classToAdd != "riddle"){
        newChat.addEventListener("click",function(){ console.log("click_chat"); this.fire("click_chat"); }.bind(this));
    }

    newChat.innerHTML = text;
    parent.appendChild(newChat);

    let newChatBB = newChat.getBoundingClientRect();
    let bbCont = parent.getBoundingClientRect();

    if (lastChat && lastChat.classList && lastChat.classList.contains("loading")) {
      let lastChatBB = lastChat.getBoundingClientRect();

      this.chatHeight[speaker] += (newChatBB.height - lastChatBB.height);
      parent.style.height = this.chatHeight[speaker] + "px";

      parent.removeChild(newChat);
      lastChat.innerHTML = text;
      lastChat.classList.remove("loading");
      if (classToAdd === "riddle") {
        lastChat.classList.add("riddle-bubble");
      } else if (classToAdd) {
        lastChat.classList.add(classToAdd);
      }
    } else {
      this.chatHeight[speaker] += newChatBB.height;
      parent.style.height = this.chatHeight[speaker] + "px";

      let tm = setTimeout(()=>{
        newChat.classList.add("ready");
      },100);
      this.chatTms.push(tm);

      tm =setTimeout(()=>{
        if(!this.hidden){
          newChat.classList.remove("hidden");
          newChat.classList.remove("hiddenBB");
          newChat.classList.add("show");
        }

      },500);
      this.chatTms.push(tm);
    }
  }


  handleChatDialogButton(mode){
    if(mode == "close"){
      this.hideAllChats();
    }

    this.fire("chat-button",mode);
  }

  updateChats(){
    let parent = document.getElementById("chat-container");
    let chatChildren = parent.querySelectorAll(".chat-bubble");
    if(chatChildren.length > 4){
      // pop oldest??
    }
  }


};
